import { filter, map, shareReplay, switchMap } from "rxjs";
import { ajax } from "rxjs/ajax";
import { jsonHeaders$ } from "services/subjects";
import { EnrollmentPoliciesResponse } from "types/dtos/responses/EnrollmentPoliciesResponse";

export const policies$ = jsonHeaders$.pipe(
    switchMap((headers) =>
        ajax<EnrollmentPoliciesResponse>({
            method: 'GET',
            url: `api/enrollment/policies`,
            headers,
        })
    ),
    filter((response) => !!response.response),
    map((response) => response.response),
    shareReplay(1),
);